export const toolkitWasClicked = {
  eventName: 'Toolkit Was Clicked'
}